export default __webpack_public_path__ + "static/media/ic-rename.6b1de207.svg";